module.exports = __webpack_public_path__ + "assets/0d3f85d23dbe6870aa394d0adcfcb424.mp3";